export default {
  // 基础操作
  ok: '确定',
  cancel: '取消',
  submit: '提交',
  save: '保存',
  edit: '编辑',
  delete: '删除',
  add: '添加',
  create: '创建',
  update: '更新',
  close: '关闭',
  confirm: '确认',
  reset: '重置',
  clear: '清空',
  search: '搜索',
  filter: '筛选',
  refresh: '刷新',
  reload: '重新加载',
  download: '下载',
  upload: '上传',
  export: '导出',
  import: '导入',
  preview: '预览',
  view: '查看',
  detail: '详情',
  change: '变更',

  // 状态提示
  success: '操作成功',
  failed: '操作失败',
  error: '错误',
  warning: '警告',
  info: '信息',
  loading: '加载中...',
  saving: '保存中...',
  submitting: '提交中...',
  processing: '处理中...',

  // 操作成功提示
  saveSuccess: '保存成功',
  deleteSuccess: '删除成功',
  addSuccess: '添加成功',
  updateSuccess: '更新成功',
  uploadSuccess: '上传成功',
  downloadSuccess: '下载成功',
  exportSuccess: '导出成功',
  importSuccess: '导入成功',

  // 操作失败提示
  saveFailed: '保存失败',
  deleteFailed: '删除失败',
  addFailed: '添加失败',
  updateFailed: '更新失败',
  uploadFailed: '上传失败',
  downloadFailed: '下载失败',
  exportFailed: '导出失败',
  importFailed: '导入失败',

  // 确认提示
  deleteConfirm: '确定要删除吗？',
  saveConfirm: '确定要保存吗？',
  resetConfirm: '确定要重置吗？',
  clearConfirm: '确定要清空吗？',

  // 表单验证
  required: '此项为必填项',
  pleaseInput: '请输入',
  pleaseSelect: '请选择',
  invalidFormat: '格式不正确',

  // 数据状态
  noData: '暂无数据',
  noResult: '无搜索结果',
  dataEmpty: '数据为空',

  // 通用状态
  enabled: '启用',
  disabled: '禁用',
  active: '激活',
  inactive: '未激活',
  online: '在线',
  offline: '离线',

  // 操作
  action: '操作',
  actions: '操作',
  operation: '操作',
  manage: '管理',
  setting: '设置',
  settings: '设置',
  config: '配置',
  backHome: '返回首页',

  // 时间相关
  today: '今天',
  yesterday: '昨天',
  tomorrow: '明天',
  thisWeek: '本周',
  thisMonth: '本月',
  thisYear: '本年',

  // 分页
  total: '共',
  items: '条',
  page: '页',
  goTo: '跳至',
  pageSize: '条/页',

  // 语言相关
  language: '语言',
  chinese: '中文',
  english: 'English',
  switchLanguage: '切换语言',

  // 账户相关
  password: '密码',
  username: '用户名',
  email: '邮箱',
  phone: '手机号',

  // 项目相关
  currentProject: '当前项目',
  selectProject: '请选择项目',
  createProject: '创建新项目',
  projectName: '项目名称',
  projectCode: '项目编号',
  projectDescription: '项目描述',
  projectCreator: '创建者',
  projectManager: '项目经理',
  pleaseInputProjectName: '请输入项目名称',
  pleaseInputProjectCode: '请输入项目编号',
  pleaseInputProjectDescription: '请输入项目描述',
  getUserInfoFailed: '获取用户信息失败，请重新登录！',

  // 应用标题
  appTitle: 'AsPiCe 开发系统',

  // 问题严重度 / 优先级 / 状态
  'severity.CRITICAL': '致命',
  'severity.MAJOR': '严重',
  'severity.MEDIUM': '一般',
  'severity.MINOR': '轻微',
  'priority.HIGHEST': '最高',
  'priority.HIGH': '高',
  'priority.MEDIUM': '中',
  'priority.LOW': '低',
  'problemStatus.CREATED': '创建',
  'problemStatus.RESOLVING': '解决中',
  'problemStatus.MODIFICATION_REVIEW': '修改审查',
  'problemStatus.RESOLVED': '已解决',
  'problemStatus.SOLUTION_APPROVED': '回归通过',
  'problemStatus.VERIFICATION_APPROVED': '验证通过',
  'problemStatus.CLOSED': '关闭',
  'discoverySource.REVIEW': '评审问题',
  'discoverySource.QUALITY_CHECK': 'QA 问题',
  'discoverySource.TEST': '测试问题',
  'discoverySource.ASSESSMENT': '认证评估问题',
  'discoverySource.OTHER': '其他',
};
